"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var iconMapping = {
  signature: _proLightSvgIcons.faSignature,
  'text-field': _proLightSvgIcons.faTextSize,
  checkbox: _proLightSvgIcons.faCheckSquare,
  radio: _freeSolidSvgIcons.faDotCircle,
  date: _freeSolidSvgIcons.faCalendarAlt,
  dropdown: _freeSolidSvgIcons.faTasks
};

var capitalizeWords = function capitalizeWords(string) {
  return string.split('-').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};

var ToolDetails = function ToolDetails(_ref) {
  var type = _ref.type;
  var iconToShow = iconMapping[type];

  if (!iconToShow) {
    return null;
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faGripHorizontal,
      className: "grip-margin faded-icon"
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faGripHorizontal,
      className: "faded-icon"
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: iconToShow,
      color: "grey",
      className: "mb-1 font-size-8"
    }),
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: "icon-subtitle"
    }, capitalizeWords(type)))
  );
};

ToolDetails.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _propTypes["default"].oneOf(['signature', 'text-field', 'checkbox', 'date', 'radio', 'dropdown']).isRequired
} : {};

var _default = exports["default"] = ToolDetails;